import { createRouter, createWebHistory, NavigationGuardNext, } from 'vue-router'
import MapView from './views/MapView.vue'
import { initFirebaseAuth } from './api/firebaseAnon';
import { collectionIndexPath, embedDomain } from './shared/domainUsers';
import { thirdPartyDomain } from './utils/DomainUtils';
import { useStore } from './store/Store';

const MapEditor = () => import('./views/MapEditor.vue');
const SignInNew = () => import('./views/SignIn.vue');
const MyMaps = () => import('./views/MyMaps.vue');
const AdminView = () => import('./views/AdminView.vue');
const Subscribe = () => import('./views/Subscribe.vue');


const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'index',
			beforeEnter: (_to, _from, next) => {
				const domain = embedDomain(window.location.hostname)
				if (domain?.collection) {
					const home = collectionIndexPath(window.location.hostname)
					if (home) next(home)
					else next()
					return
				}
				if (thirdPartyDomain()) next()
				else next("/web/maps")
			},
			component: { render: () => null },
		},
		{
			path: '/web/subscription/:plan?',
			name: 'subscription',
			component: Subscribe,
			meta: {
				needsSignIn: true,
				dotSe: false,
			}

		},
		{
			path: '/web/maps',
			name: 'maps',
			component: MyMaps,
			meta: {
				needsSignIn: true,
			}
		},
		{
			path: '/web/admin',
			name: 'admin',
			component: AdminView,
			meta: {
				needsSignIn: true,
			}
		},


		{
			path: '/create',
			name: 'create',
			component: MapEditor,
			meta: {
				needsSignIn: true,
				isNew: true,
			},
		},
		{
			path: '/signin',
			name: 'signin',
			component: SignInNew,
			meta: {
				isSignIn: true,
			},
		},
		{
			path: '/signup',
			name: 'signup',
			component: SignInNew,
			meta: {
				isSignIn: true,
			},
		},
		{
			path: '/resetpassword',
			name: 'resetpassword',
			component: SignInNew,
			meta: {
				isSignIn: true,
			},
		},
		{
			path: '/:id/draft/:slug1?/:slug2?',
			name: 'map-draft',
			component: MapView,
			meta: {
				needsSignIn: true,
				draft: true,
			}
		},
		{
			path: '/:id/edit',
			name: 'edit',
			component: MapEditor,
			meta: {
				needsSignIn: true,
				isNew: false,
			},
		},
		{
			path: '/:id/:slug1?/:slug2?',
			name: 'map',
			component: MapView,
		},
	]
})

function triggerNext(next: NavigationGuardNext, then: string, needsSignIn: boolean, signedIn: boolean) {
	if (signedIn || !needsSignIn)
		next();
	else
		next({ path: "/signin", query: { then: then } });
}


router.beforeEach(async (to, from, next) => {

	let signedIn = false
	if (to.meta?.needsSignIn || to.meta?.isSignIn) {
		signedIn = await initFirebaseAuth()
	}

	// An embed domain may open any map path. The Worker map load allows that domain's User or Organization.
	if (thirdPartyDomain()) {
		if (to.meta?.needsSignIn || to.meta?.isSignIn) {
			next("/")
			return
		}

		const mapId = to.params.id
		if (typeof mapId !== "string" || mapId === "") {
			const home = embedDomain(window.location.hostname)?.homeMapId
			next(home || "/")
			return
		}

		next()
		return
	}

	triggerNext(next, to.fullPath, to.meta?.needsSignIn as boolean, signedIn);
})

export default router
